import Container from "./Container";
import Text from "./Text";
import { Separator } from "./ui/separator";
import { AppTheme } from "@/utils/constants/theme";
import { Button } from "./ui/button";
import { useNavigate } from "@/hooks/useNavigate";

const NotFound = () => {
  const nav = useNavigate();
  return (
    <Container
      cornerRadius={0}
      hFull
      flexDisplay
      itemsAlign="center"
      contentAlign="center"
      gap={10}
    >
      <Container
        indention={0}
        flexDisplay
        direction="row"
        itemsAlign="center"
        contentAlign="center"
        gap={20}
      >
        <Text size={50} bold color={AppTheme.darkBurgundy}>
          404
        </Text>
        <Separator orientation="vertical" color={AppTheme.darkMidnigthBlue} />
        <Text size={50} bold>
          Page Not Found
        </Text>
      </Container>
      <Container indention={0}>
        <Text>Ooops! This page doesn't exist.</Text>
      </Container>
      <Button className="mt-2" onClick={() => nav({ path: "" })}>
        Go Back to Home Page
      </Button>
    </Container>
  );
};

export default NotFound;
